export default __webpack_public_path__ + "static/media/maintenanceicon.a8c0eedd.svg";